import { Action, configureStore, ThunkAction } from '@reduxjs/toolkit';
import { reducer as project } from './slices/projectSlice';
import { reducer as scene } from './slices/sceneSlice';
import { reducer as variants } from './slices/variantsSlice';
import { reducer as variables } from './slices/variablesSlice';
import { reducer as inputs } from './slices/inputsSlice';
import { reducer as tenant } from './slices/tenantSlice';
import { reducer as fonts } from './slices/fontsSlice';
import { reducer as resources } from './slices/resourcesSlice';
import { reducer as meta } from './slices/metaSlice';
import { publicAssets } from './apis/publicAssets';

const reducer = {
    [publicAssets.reducerPath]: publicAssets.reducer,
    project,
    scene,
    variants,
    variables,
    inputs,
    tenant,
    fonts,
    meta,
    resources
};

export function createStore(state: WebsiteState | undefined = undefined) {
    return configureStore({
        preloadedState: state,
        reducer,
        middleware: (getDefaultMiddleware) =>
            getDefaultMiddleware().concat(publicAssets.middleware)
    });
}

// reducer and middleware defined only for `typeof` purposes
const __store = configureStore({ reducer, middleware: m => m() });
export type AppStore = typeof __store;
export type AppDispatch = typeof __store.dispatch;
export type WebsiteState = ReturnType<typeof __store.getState>;

export type AppThunk<ReturnType = void> = ThunkAction<ReturnType,
    WebsiteState,
    unknown,
    Action<string>>;

export type AppThunkApiConfig = {
    state: WebsiteState,
    dispatch: AppDispatch
};

export type AppThunkApi = {
    dispatch: AppDispatch,
    getState: () => WebsiteState
};